import * as React from "react";

const DocumentIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M15 2.643v1.5c0 1.414 0 2.121.44 2.56.439.44 1.146.44 2.56.44h1.5"
    ></path>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M4 16.143v-8C4 5.314 4 3.9 4.879 3.02c.878-.878 2.293-.878 5.121-.878h4.172c.408 0 .613 0 .797.076.183.076.328.22.617.51l3.828 3.828c.29.29.434.434.51.617.076.184.076.388.076.797v8.172c0 2.828 0 4.242-.879 5.121-.878.879-2.293.879-5.121.879h-4c-2.828 0-4.243 0-5.121-.879S4 18.971 4 16.143M8 11.143h8m-8 3h8m-8 3h4.17"
    ></path>
  </svg>
);

export default DocumentIcon;
